module.exports = "https://coursera_assets.s3.amazonaws.com/images/3576baa607ee6764890ce3da9681de90.png";